var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section main-section--num bg-gray-f5"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('div', [_c('div', {
    staticClass: "icon-num-items"
  }, _vm._l(_vm.items, function (_ref, i) {
    var text = _ref.text,
        value = _ref.value,
        unit = _ref.unit,
        icon = _ref.icon;
    return _c('div', {
      key: "summary-item-".concat(i),
      staticClass: "icon-num-item"
    }, [_c('div', {
      staticClass: "icon-num-item__icon",
      style: "background-image:url(".concat(icon, ");")
    }), _c('div', {
      staticClass: "icon-num-item__tit text-18 text-md-16"
    }, [_vm._v(_vm._s(text))]), _c('div', {
      staticClass: "icon-num-item__num"
    }, [_c('strong', {
      staticClass: "color-primary"
    }, [_vm._v(_vm._s(value))]), _c('small', [_vm._v(_vm._s(unit))])])]);
  }), 0)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-60 mb-md-30 "
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "text-40 text-lg-30 text-md-24 font-weight-regular"
  }, [_vm._v("e이음은 "), _c('strong', [_vm._v("여러분의 많은 참여를 기다립니다.")])])])]);
}]

export { render, staticRenderFns }